export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const h1 = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
    $widgetHTML.find('span.card-widget-title').html(h1);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      if (data.items.length < 1) {
        $widgetHTML.remove();
      } else {
        modifyTitle(data);
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
